import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { StyledRightBlock, StyledCross } from './styled';

import TeamSquad from './pages/TeamSquad';
import TransfersSearch from './pages/TransfersSearch';
import TransfersDeals from './pages/TransfersDeals';
import { isFilterShown } from '../../../../redux/selector/Transfers';
import {
  StyledTransfersSearch,
  StyledContainerForFilter,
} from './pages/TransfersSearch/styled';

const SquadFilterHost = () => {
  const isShownFilter = useSelector(isFilterShown);
  return (
    <StyledTransfersSearch isShownFilter={isShownFilter}>
      <StyledContainerForFilter className="filter-container" />
    </StyledTransfersSearch>
  );
};

export default React.memo(function RightSideBlock({
  isRightOpen,
  hasTopHeader,
  sidebarOpenRightPanel,
}) {
  return (
    <StyledRightBlock
      className="right-sidebar"
      data-right={isRightOpen}
      hasTopHeader={hasTopHeader}
    >
      <StyledCross onClick={() => sidebarOpenRightPanel(false)} />
      <Switch>
        <Route path="/transfers/deals" component={TransfersDeals} />
        <Route path="/transfers/search-players" component={TransfersSearch} />
        <Route path="/transfers/shortlist" component={TransfersSearch} />
        <Route
          path="/team/squad"
          render={() => (
            <>
              <SquadFilterHost />
              <TeamSquad />
            </>
          )}
        />
        <Route
          path="/team/strategy"
          render={() => <TeamSquad isMobileView />}
        />
      </Switch>
    </StyledRightBlock>
  );
});
